export default defineNuxtPlugin(() => {
  if (import.meta.client) {
    const config = useRuntimeConfig();
    const status = useDixaStatus();
    const w = window as DixaWindow;

    // Without a token the messenger can never open a conversation, so mark it
    // unavailable up front and let customer support fall back to email.
    if (!config.public.dixaMessengerToken) {
      status.value = 'failed';
      return;
    }

    // Initialize _dixa_ object if it doesn't exist
    if (!w._dixa_) {
      w._dixa_ = {
        invoke: function (m, a) {
          w._dixa_!.pendingCalls = w._dixa_!.pendingCalls || [];
          w._dixa_!.pendingCalls.push([m, a]);
        },
        addListener: function (event, listener) {
          w._dixa_!.pendingAddListenerCalls =
            w._dixa_!.pendingAddListenerCalls || [];
          w._dixa_!.pendingAddListenerCalls.push([event, listener]);
        }
      };
    }

    // Create script element
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.charset = 'utf-8';
    script.async = true;
    script.src = 'https://messenger.dixa.io/bootstrap.js';

    // Handle successful load. This only means the bootstrap script arrived —
    // whether the messenger actually opens is verified at click time, since
    // an invalid token or a non-whitelisted domain fails silently here.
    script.onload = () => {
      w._dixa_!.invoke('init', {
        messengerToken: config.public.dixaMessengerToken
      });
      status.value = 'loaded';
    };

    // Handle script load error — customer support falls back to email
    script.onerror = () => {
      status.value = 'failed';
    };

    // Insert script tag before the first script tag on the page
    const firstScriptTag = document.getElementsByTagName('script')[0];
    if (firstScriptTag.parentNode) {
      firstScriptTag.parentNode.insertBefore(script, firstScriptTag);
    }
  }
});
